/**
 * Uploads Table Header Configuration
 * Defines column structure for the Uploads tab table
 */

export interface TableHeaderColumn {
  visible: boolean;
  field: string;
  title: string;
  /** When set, header shows this icon instead of title (e.g. 'clock' for Duration) */
  iconKey?: string;
  sort: boolean;
  filter: boolean;
  type: string;
  isUp: boolean;
  width: number | string;
  value: boolean;
  restore: boolean;
  align: 'left' | 'right' | 'center';
  /** Optional padding override (e.g. '12px 12px' for tighter column) */
  padding?: string;
}

export const uploadsTableHeader: TableHeaderColumn[] = [
  {
    visible: true,
    field: 'clip',
    title: 'Clip',
    sort: false,
    filter: false,
    type: 'video',
    isUp: false,
    width: 138,
    value: false,
    restore: false,
    align: 'left',
  },
  {
    visible: true,
    field: 'name_description',
    title: 'Name',
    sort: true,
    filter: false,
    type: 'string',
    isUp: false,
    width: 346,
    value: false,
    restore: false,
    align: 'left',
  },
  {
    visible: true,
    field: 'clips_count',
    title: 'Clipz',
    sort: false,
    filter: false,
    type: 'number',
    isUp: false,
    width: 90,
    value: false,
    restore: false,
    align: 'left',
  },
  {
    visible: true,
    field: 'date_added',
    title: 'Date Uploaded',
    sort: true,
    filter: false,
    type: 'date',
    isUp: false,
    width: 160,
    value: false,
    restore: false,
    align: 'left',
  },
  {
    visible: true,
    field: 'date_processed',
    title: 'Processing Time',
    sort: false,
    filter: false,
    type: 'date',
    isUp: false,
    width: 150,
    value: false,
    restore: false,
    align: 'left',
  },
  {
    visible: true,
    field: 'actions',
    title: '',
    sort: false,
    filter: false,
    type: 'actions',
    isUp: false,
    width: 'auto',
    value: false,
    restore: false,
    align: 'right',
  },
];
